var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center fill-height"},[_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"err-number"},[_vm._v("500")]),_c('h1',[_vm._v("failed to connect to server")]),_c('p',[_vm._v("try again later ")])])])
}]

export { render, staticRenderFns }